import { DeleteConfirmModal } from '../../../../../components/DeleteConfirmModal';
import { TransformationRenderer } from './components/TransformationRenderer';
import { PermissionGuard } from '../../../../../components/PermissionGuard';
import toast from 'react-hot-toast';
import { extractApiError } from '../../../../../utils';

import { transportationLabels } from '../../../../../consts/conditions';
import React, { memo, useEffect, useRef, useState } from 'react';
import { Body } from './style';

import { TbPlus } from 'react-icons/tb';
import { IoClose, IoEyeOffOutline } from 'react-icons/io5';

import TrashImg from '../../../../../assets/images/trash_icon.png';
import TransformationItem from './components/TransformationItem';

import {
  ActionIcon,
  Box,
  Button,
  Flex,
  LoadingOverlay,
  Overlay,
  Text,
  Tooltip,
  rem
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { MdOutlineRemoveRedEye } from 'react-icons/md';

import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import { observer } from 'mobx-react-lite';
import extractionStore from '../../../store';
import { TbLayoutSidebarLeftExpand } from 'react-icons/tb';
import { TbLayoutSidebarRightExpand } from 'react-icons/tb';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import { scrollToElement } from '../../../../../utils';
import { NoteDrawer } from './components/NoteDrawer';
import { checkHasAiActions } from './utils';
import { LuDownload, LuUpload } from 'react-icons/lu';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';

import { v4 as uuidv4 } from 'uuid';
import { BiInfoCircle } from 'react-icons/bi';

const TransformationSidebar = observer(
  ({
    stepIn,
    periodId,
    workflowId,
    columns,
    extractId,
    isFetching,
    disableAddAction,
    tranformationId,
    isOriginalView,
    amongIndex,
    toggleStepIn,
    transformations,
    addTransformation,
    tableName,
    setAmongIndex,
    editTransformation,
    toggleOriginalView,
    removeTransformation,
    isLoadingTransformations,
    isLoadingTransformationPatch,
    handleSaveTransformations,
    transformationGarbageCollector,
    setTransformations,
    year,
    width,
    refetch,
    periodName,
    workflowName,
    setIsNewAction,
    isLockedPeriod,
    changeActiveTab,
    canManageWorkflow = false
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [deletableIndex, setDeletableIndex] = useState();
    const [selectedTransformation, setSelectedTransformation] = useState(null);
    const [initialFilterTypes, setInitialFilterTypes] = useState([]);
    const [selectedNoteTransformation, setSelectedNoteTransformation] = useState(null);
    const [mode, setMode] = useState('history'); // history, import , export
    const [selectedActions, setSelectedActions] = useState([]);
    const fileInputRef = useRef(null);
    const replaceFileInputRef = useRef(null);
    const disableActionButtons = mode === 'import' || mode === 'export';

    const { isSidebarExpanded, toggleExpandSidebar } = extractionStore;

    useEffect(() => {
      scrollToElement('active_transformation-item', { block: 'end' });
    }, [transformations]);

    useEffect(() => {
      return () => {
        transformationGarbageCollector();
      };
    }, []);

    const [transformationType, setTransformationType] = useState();

    const handleDelete = idx => {
      removeTransformation(idx, {
        onSuccess: () => {
          setDeletableIndex();
          toggleStepIn();
        }
      });
    };

    const isDeleteModalOpen = deletableIndex === null || deletableIndex !== undefined;

    const [filterActions, setFilterActions] = useState();

    const [opened, { open, close }] = useDisclosure(false);

    const onChangeTransformationType = _value => {
      setTransformationType(_value);
      setFilterActions('');
    };

    const handleClose = () => {
      setTransformationType();
      setInitialFilterTypes([]);
      setSelectedTransformation(null);
      onChangeTransformationType(null);
      setIsNewAction(false);
      setAmongIndex(null);
      close();
    };
    const handleEditTransformation = (idx, transformation) => {
      if (selectedTransformation !== idx) {
        toggleStepIn(idx + 1);

        setSelectedTransformation(idx);
        onChangeTransformationType(transformation[0].label);
        setInitialFilterTypes(transformation);
        open();
      } else {
        handleClose();
      }
    };

    const reorder = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
      return result;
    };

    const onDragEnd = result => {
      const { source, destination } = result;

      if (!destination) {
        return;
      }

      if (source.index === destination.index) {
        return;
      }

      const reorderedItems = reorder(transformations, source.index, destination.index);

      handleSaveTransformations(reorderedItems);
      setTransformations(reorderedItems);
    };

    const renderSidebarActions = () => {
      return (
        <Flex align="center">
          <ActionIcon
            variant="transparent"
            c="#ADB5BD"
            onClick={() => toggleExpandSidebar(!isSidebarExpanded)}
          >
            {!isSidebarExpanded ? (
              <TbLayoutSidebarLeftExpand size={20} />
            ) : (
              <TbLayoutSidebarRightExpand size={20} />
            )}
          </ActionIcon>
        </Flex>
      );
    };

    const handleInsertActionAmong = idx => {
      setAmongIndex(idx);
      setTransformationType();
      setInitialFilterTypes([]);
      setSelectedTransformation(null);
      onChangeTransformationType(null);
      open();
    };

    const handleAddAction = () => {
      setIsNewAction(true);
      open();
      setInitialFilterTypes([]);
      setTransformationType();
    };

    const onCancel = () => {
      setMode('history');
      setSelectedActions([]);
    };

    const onToggleAction = actionId => {
      setSelectedActions(
        selectedActions.includes(actionId)
          ? selectedActions.filter(id => id !== actionId)
          : [...selectedActions, actionId]
      );
    };

    const replaceActionsFromJson = event => {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = e => {
        try {
          const json = JSON.parse(e.target.result);
          const res = [...transformations, ...json].filter(t => !selectedActions.includes(t.id));

          if (Array.isArray(json)) {
            setTransformations(res);
          }

          handleSaveTransformations(res);
          onCancel();
        } catch (err) {
          toast.error(
            extractApiError(err, 'Failed to import actions. Please check the file format.')
          );
        }
      };
      reader.readAsText(file);

      event.target.value = '';
    };

    const importActionsFromJson = event => {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = e => {
        try {
          const json = JSON.parse(e.target.result);
          const res = [...transformations, ...json];

          if (Array.isArray(json)) {
            setTransformations(res);
          }

          handleSaveTransformations(res);
          onCancel();
        } catch (err) {
          toast.error(
            extractApiError(err, 'Failed to import actions. Please check the file format.')
          );
        }
      };
      reader.readAsText(file);

      event.target.value = '';
    };

    const exportSelectedActionsToJson = () => {
      if (!transformations || selectedActions.length === 0) return;

      const selected = transformations
        .filter(t => selectedActions.includes(t.id))
        .map(t => {
          delete t.data;

          return {
            ...t,
            systemId: uuidv4(),
            id: uuidv4()
          };
        });
      const dataStr = JSON.stringify(selected, null, 2);
      const blob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'actions-export.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      onCancel();
    };

    const isSelectAll = selectedActions.length === transformations.length;

    const handleToggleAll = () => {
      setSelectedActions(isSelectAll ? [] : transformations.map(t => t.id));
    };

    if (opened)
      return (
        <Box
          id="grid-table-sidebar-open-root"
          bg="white"
          w="100%"
          display="flex"
          sx={() => ({
            borderRadius: '4px',
            overflow: 'auto',
            flexDirection: 'column'
          })}
        >
          <LoadingOverlay
            id="grid-table-sidebar-open-loading"
            visible={isLoadingTransformationPatch || isLoadingTransformations}
            zIndex={1000}
            overlayProps={{ radius: 'sm', blur: 2 }}
          />

          <Flex
            id="grid-table-sidebar-open-header"
            w="100%"
            align="center"
            justify="space-between"
            p={rem(16)}
          >
            <Flex id="grid-table-sidebar-open-header-left" align="center" gap={rem(8)}>
              <ActionIcon
                id="grid-table-sidebar-open-close"
                onClick={handleClose}
                size={rem(16)}
                variant="transparent"
                color="#868E96"
              >
                <FaArrowLeft />
              </ActionIcon>

              <Text id="grid-table-sidebar-open-title" c="dark.7" fz="16px">
                Select Action
              </Text>
            </Flex>

            {renderSidebarActions()}
          </Flex>

          <Body id="grid-table-sidebar-open-body">
            <TransformationRenderer
              year={year}
              key={transformationType + 'type'}
              setIsOpen={setIsOpen}
              filterActions={filterActions}
              onChangeTransformationType={onChangeTransformationType}
              setSelectedTransformation={setSelectedTransformation}
              selectedTransformation={selectedTransformation}
              columns={columns}
              transformationType={transformationType}
              setTransformationType={setTransformationType}
              addTransformation={addTransformation}
              editTransformation={editTransformation}
              amongIndex={amongIndex}
              setAmongIndex={setAmongIndex}
              tranformationId={tranformationId}
              extractId={extractId}
              setDeletableIndex={setDeletableIndex}
              periodId={periodId}
              stepIn={stepIn}
              workflowId={workflowId}
              toggleStepIn={toggleStepIn}
              transformations={transformations}
              tableName={tableName}
              isLoadingTransformationPatch={isLoadingTransformationPatch}
              showAction
              onOpenAdd={open}
              close={handleClose}
              periodName={periodName}
              workflowName={workflowName}
              handleSaveTransformations={handleSaveTransformations}
              initialFilterTypes={initialFilterTypes}
              disableSelectActionType={initialFilterTypes?.length > 0}
              isLockedPeriod={isLockedPeriod}
            />
          </Body>
        </Box>
      );

    return (
      <>
        <DeleteConfirmModal
          isOpen={isDeleteModalOpen}
          image={TrashImg}
          onClose={() => setDeletableIndex()}
          onConfirm={() => handleDelete(deletableIndex)}
          isLoading={isLoadingTransformationPatch}
          submitLabel="Yes, Delete"
          cancelLabel="Cancel"
          title={`Delete ${transportationLabels[transformations?.[deletableIndex]?.name]} Action`}
          description={`Are you sure you want to delete ${
            transportationLabels[transformations?.[deletableIndex]?.name]
          } action?`}
        />

        <Box
          id="grid-table-sidebar-root"
          p="16px"
          pt={0}
          bg="white"
          w="100%"
          pos="relative"
          sx={() => ({
            borderRadius: '4px',
            overflow: 'auto'
          })}
        >
          <LoadingOverlay
            id="grid-table-sidebar-loading"
            visible={isLoadingTransformationPatch || isLoadingTransformations}
            zIndex={1000}
            overlayProps={{ radius: 'sm', blur: 2 }}
          />

          <Flex
            id="grid-table-sidebar-header"
            w="100%"
            direction="column"
            pos="sticky"
            top={0}
            bg="white"
            sx={() => ({ zIndex: 9999 })}
            pt={rem(16)}
            pb={rem(16)}
          >
            <Flex w="100%" align="center" justify="space-between" mb={rem(16)}>
              <Flex id="grid-table-sidebar-header-title" align="center">
                <Text id="grid-table-sidebar-title" c="dark.7" fz="16px">
                  Transformation Actions
                </Text>
              </Flex>

              {renderSidebarActions()}
            </Flex>

            {disableAddAction && (
              <Flex align="center" justify="center" direction="column" gap={16}>
                <Box
                  mt={44}
                  display="flex"
                  bd="1px solid #FF922B"
                  w={32}
                  h={32}
                  sx={() => ({
                    borderRadius: '16px',
                    alignItems: 'center',
                    justifyContent: 'center'
                  })}
                >
                  <BiInfoCircle color="#FF922B" fontSize={16} />
                </Box>

                <Text fz={14} fw={600} c="orange.6">
                  Transformation Not Available Yet
                </Text>
                <Text c="dark.6" fz={14} fw={400} ta="center">
                  Transformation can be started once the automated
                  <br /> transformation process has begun.
                </Text>

                <Button
                  id="grid-table-sidebar-go-extraction"
                  c="orange.6"
                  fw={400}
                  fz={14}
                  variant="transparent"
                  rightSection={<FaArrowRight />}
                  onClick={() => changeActiveTab('extraction')}
                >
                  Go to Extraction
                </Button>
              </Flex>
            )}

            {!disableAddAction && (
              <>
                <Box>
                  <Flex align="center" justify="space-between" pos="relative">
                    <Overlay
                      visible={disableActionButtons}
                      hidden={!disableActionButtons}
                      blur={0}
                      zIndex={1000}
                      opacity={0.5}
                      bg="white"
                    />
                    {!isLockedPeriod ? (
                      <Flex align="center">
                        <PermissionGuard allowed={canManageWorkflow}>
                          <Button
                            id="grid-table-sidebar-add-action"
                            onClick={handleAddAction}
                            leftSection={
                              disableAddAction ? (
                                <BiInfoCircle
                                  fontSize="16px"
                                  data-tooltip-id="ligth-tooltip"
                                  data-tooltip-content="Transformation is not possible until the automated transformation process has started."
                                />
                              ) : (
                                <TbPlus fontSize="16px" />
                              )
                            }
                            size="xs"
                            variant="outline"
                            disabled={disableAddAction || !canManageWorkflow}
                          >
                            Add Action
                          </Button>
                        </PermissionGuard>
                      </Flex>
                    ) : (
                      <div />
                    )}

                    {transformations?.length > 0 && (
                      <Button
                        leftSection={
                          isOriginalView ? <MdOutlineRemoveRedEye /> : <IoEyeOffOutline />
                        }
                        size="xs"
                        variant="subtle"
                        onClick={toggleOriginalView}
                        disabled={isFetching || disableActionButtons}
                      >
                        Show Original
                      </Button>
                    )}
                  </Flex>
                </Box>

                <Flex
                  id="grid-table-sidebar-history-row"
                  justify="space-between"
                  align="center"
                  mt={rem(12)}
                >
                  <Text id="grid-table-sidebar-history-title" c="dark.7" size="14px" fw={600}>
                    Action History
                  </Text>

                  {!disableActionButtons ? (
                    <Flex id="grid-table-sidebar-history-actions" gap={4}>
                      <PermissionGuard allowed={canManageWorkflow}>
                        <Tooltip content="Export Actions" label="Export Actions">
                          <ActionIcon
                            id="grid-table-sidebar-export-actions"
                            variant="transparent"
                            onClick={() => setMode('export')}
                            disabled={disableAddAction || !canManageWorkflow}
                          >
                            <LuDownload />
                          </ActionIcon>
                        </Tooltip>
                      </PermissionGuard>

                      {!isLockedPeriod && (
                        <PermissionGuard allowed={canManageWorkflow}>
                          <Tooltip content="Import Actions" label="Import Actions">
                            <ActionIcon
                              id="grid-table-sidebar-import-actions"
                              variant="transparent"
                              onClick={() => setMode('import')}
                              disabled={disableAddAction || !canManageWorkflow}
                            >
                              <LuUpload />
                            </ActionIcon>
                          </Tooltip>
                        </PermissionGuard>
                      )}
                    </Flex>
                  ) : (
                    <Flex>
                      <Button
                        id="grid-table-sidebar-select-all"
                        leftSection={
                          isSelectAll ? (
                            <ImCheckboxChecked size={12} />
                          ) : (
                            <ImCheckboxUnchecked size={12} />
                          )
                        }
                        size="xs"
                        variant="subtle"
                        onClick={handleToggleAll}
                      >
                        {isSelectAll ? 'Deselect All' : 'Select All'}
                      </Button>

                      <Button
                        id="grid-table-sidebar-cancel-selection"
                        leftSection={<IoClose size={12} />}
                        size="xs"
                        variant="subtle"
                        onClick={onCancel}
                      >
                        Cancel
                      </Button>
                    </Flex>
                  )}
                </Flex>
              </>
            )}
          </Flex>

          {!disableAddAction && (
            <Box>
              <Body id="grid-table-sidebar-list-body">
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="transformations_drag_n_drop">
                    {dropProvided => (
                      <Flex
                        id="grid-table-sidebar-list"
                        direction="column"
                        {...dropProvided.droppableProps}
                        ref={dropProvided.innerRef}
                      >
                        {transformations?.map((transform, idx) => {
                          const errorIndex = transformations?.findIndex(el => !!el.error) || null;
                          const showReRunAiActions = checkHasAiActions(transform);
                          const isSelected = selectedActions.includes(transform.id);
                          const isUnavailable = errorIndex >= 0 && errorIndex < idx;
                          const isSelectable = mode === 'import' || mode === 'export';
                          const key = `${isSelected ? 'selected-transform' : 'transform'}-${idx}`;

                          return (
                            <Draggable
                              draggableId={`draggable-t-item-${idx}`}
                              index={idx}
                              key={key}
                            >
                              {(dragProvided, dragSnapshot) => (
                                <div
                                  ref={dragProvided.innerRef}
                                  {...dragProvided.draggableProps}
                                  style={{
                                    ...dragProvided.draggableProps.style,
                                    opacity: dragSnapshot.isDragging ? 0.5 : 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    maxWidth: width - 50
                                  }}
                                >
                                  <TransformationItem
                                    transform={transform}
                                    setAmongIndex={handleInsertActionAmong}
                                    amongIndex={amongIndex}
                                    onDelete={setDeletableIndex}
                                    handleEditTransformation={handleEditTransformation}
                                    toggleStepIn={toggleStepIn}
                                    isUnavailable={isUnavailable}
                                    onEditNote={() => setSelectedNoteTransformation(transform)}
                                    isSelectable={isSelectable}
                                    isSelected={isSelected}
                                    onToggle={() => onToggleAction(transform.id)}
                                    onSelectFilterType={val => {
                                      setTransformationType();
                                      setTransformationType(val);
                                    }}
                                    dragProvided={dragProvided}
                                    stepIn={stepIn}
                                    showReRunAiActions={showReRunAiActions}
                                    idx={idx}
                                    onClear={handleClose}
                                    panelWidth={width}
                                    transformationId={tranformationId}
                                    disableMenu={isLockedPeriod}
                                    selectedTransformation={selectedTransformation}
                                    addTransformation={addTransformation}
                                    canManageWorkflow={canManageWorkflow}
                                  />
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                      </Flex>
                    )}
                  </Droppable>
                </DragDropContext>

                {mode === 'import' && (
                  <Flex
                    w="100%"
                    justify="end"
                    gap="16px"
                    mt={rem(16)}
                    pos="sticky"
                    bottom={0}
                    bg="white"
                    pt={rem(16)}
                  >
                    <Button
                      size="xs"
                      variant="outline"
                      leftSection={<LuUpload />}
                      disabled={selectedActions.length === 0}
                      onClick={() => replaceFileInputRef.current.click()}
                    >
                      Replace Actions {selectedActions.length > 0 && `(${selectedActions.length})`}
                    </Button>
                    <Button
                      size="xs"
                      variant="outline"
                      leftSection={<LuUpload />}
                      onClick={() => fileInputRef.current.click()}
                    >
                      Import Actions
                    </Button>
                  </Flex>
                )}

                {mode === 'export' && (
                  <Flex
                    w="100%"
                    justify="end"
                    gap="16px"
                    mt={rem(16)}
                    pos="sticky"
                    bottom={0}
                    bg="white"
                    pt={rem(16)}
                  >
                    <Button
                      size="xs"
                      leftSection={<LuDownload />}
                      disabled={selectedActions.length === 0}
                      onClick={exportSelectedActionsToJson}
                    >
                      Export {selectedActions.length > 0 && `(${selectedActions.length})`}
                    </Button>
                  </Flex>
                )}
              </Body>
            </Box>
          )}
        </Box>

        <NoteDrawer
          title="Add Action Note"
          isOpen={!!selectedNoteTransformation}
          onClose={() => setSelectedNoteTransformation(null)}
          value={selectedNoteTransformation?.note}
          autoNote={selectedNoteTransformation?.auto_note}
          label={selectedNoteTransformation?.name}
          transformId={tranformationId}
          stepId={selectedNoteTransformation?.id}
          onSubmit={refetch}
        />

        <input
          type="file"
          onChange={importActionsFromJson}
          style={{ display: 'none' }}
          accept=".json"
          ref={fileInputRef}
        />

        <input
          type="file"
          onChange={replaceActionsFromJson}
          style={{ display: 'none' }}
          accept=".json"
          ref={replaceFileInputRef}
        />
      </>
    );
  }
);

export default memo(TransformationSidebar);
